import { TResellerBranding } from '@/reseller/reseller.types';

const DEFAULT_RESELLER = 'sda';

// Branding lives at the env/build level (VITE_APP_SUPER_TENANT), not on the
// theme — light/midnight themes are shared across resellers, so the theme
// cannot be trusted to carry the reseller identity.
const resellerBranding = import.meta.glob<{ BRANDING: TResellerBranding }>(
  '../../../reseller/*/branding/branding.constants.ts',
  { eager: true },
);

const findBranding = (resellerName: string): TResellerBranding | undefined => {
  const entry = Object.entries(resellerBranding).find(([path]) =>
    path.includes(`/${resellerName}/branding/branding.constants.ts`),
  );

  return entry?.[1].BRANDING;
};

export const getResellerBranding = (): TResellerBranding => {
  const resellerName =
    import.meta.env.VITE_APP_SUPER_TENANT?.toLowerCase() ?? DEFAULT_RESELLER;

  return findBranding(resellerName) ?? findBranding(DEFAULT_RESELLER)!;
};
